<!-- <p>user-event-dialog works!</p> -->
<h2 mat-dialog-title>{{ data.eventTitle }}</h2>
<div mat-dialog-content>
  <p>Event Host Name: {{ data.eventHost }}</p>
  <p>Event Guests Count: {{ data.eventGuestsCount }}</p>
  <p>Event Create Date: {{ data.eventCreateDate | date }}</p>
  <p>Event Date: {{ data.eventDate | date }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
